<div class="toolview" [style.height.px]="iframeHeight">
  <ng-container *ngIf="ispreloading===true">
    <img class="preloadergif" alt="preloader" src="../../../assets/preloader.gif"/>
    <div class="preloader"></div>
  </ng-container>
  <ng-container *ngIf="iframesource">
    <iframe allow="fullscreen" id="iframe_container" width="100%" height="100%"
            [src]="iframesource" (load)="onIFrameLoaded()"></iframe>
  </ng-container>
</div>
